import { render, staticRenderFns } from "./StudentPosterProduct.vue?vue&type=template&id=3dc0e254&scoped=true&"
import script from "./StudentPosterProduct.vue?vue&type=script&lang=js&"
export * from "./StudentPosterProduct.vue?vue&type=script&lang=js&"
import style0 from "./StudentPosterProduct.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc0e254",
  null
  
)

export default component.exports